import { HeaderSkeleton, SkeletonRegion, TableSkeleton } from '@ems/ui/patterns/skeleton-blocks'

export function LeaderboardSkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-6">
      <HeaderSkeleton
        title="w-48"
        description="w-24"
        actions={['h-[22px] w-20', 'h-[22px] w-24']}
      />
      <TableSkeleton
        rows={8}
        card={{ title: 'w-28', description: null }}
        columns={[
          { cell: 'muted', widths: ['w-4'], hideOnCard: true, shrink: true, header: 'w-4' },
          { cell: 'mono', widths: ['w-12', 'w-16'] },
          { cell: 'text', widths: ['w-40', 'w-32', 'w-48'], primary: true },
          { cell: 'text', widths: ['w-8', 'w-6'], align: 'end' },
        ]}
      />
    </SkeletonRegion>
  )
}
